import { default as term } from './term/routes'
import { default as signature } from './signature/routes'
import { default as term_tag } from './term_tag/routes'

export default [
    ...term,
    ...signature,
    ...term_tag,
]